<template lang="pug">
  div(v-loading='loading')
    el-card(shadow="hover")
      p.padding-titulo Pesquisa de Modelos
      el-input(
        placeholder='Informe a descrição'
        v-model='pesquisa'
        @keypress.native.enter='pesquisarModelos'
      )
        el-button(slot='append' icon='el-icon-search' @click='pesquisarModelos')
      .botao-limpar(@click='limpar') Limpar

    el-card(shadow="hover" style='margin-top: 20px;')
      .header
        .titulo-tabela Listagem de modelos
        el-button(
          type='primary'
          icon='el-icon-plus'
          size='small'
          @click='abrirModalAdicionar'
        ) Adicionar modelo
      divider(label='')
      el-table(
        :data='modelos'
        style='width: 100%; padding-top: 10px;'

        :default-sort="{ prop: 'modelo.modelo', order: 'descending' }"
      )
        template(slot='empty') Não existem modelos disponíveis
        el-table-column(
          prop='assunto'
          label='Descrição'
          header-align='left'
          align='left'
          sortable
        )
        el-table-column(
          prop='usuario.pessoa.nomeRazaoSocial'
          label='Responsável'
          header-align='left'
          align='left'
          sortable
        )
        el-table-column(
          label='Ações',
          width='110',
          header-align='center',
          align='center'
        )
          template(slot-scope='scope')
            el-dropdown(trigger='click')
                el-button(type='primary' size='medium') Ações
                  i.marginLeft5(class='fas fa-chevron-down')
                el-dropdown-menu(slot='dropdown')
                  el-dropdown-item(@click.native='abrirModelo(scope.row)')
                    i(class='fa fa-eye')
                      span.marginLeft5 Visualizar
                  el-dropdown-item(@click.native='editarModelo(scope.row)')
                    i(class='fa fa-edit')
                      span.marginLeft5 Editar
                  el-dropdown-item(@click.native='excluirModelo(scope.row.id)')
                    i(class='fa fa-trash')
                      span.marginLeft5 Excluir

    modal-novo-modelo(
      v-if='showModalAdicionar'
      :modalOpen='showModalAdicionar'
      :modelo='modeloEditar'
      @close-modal='closeModal()'
      @modelo-cadastrado='refresh()'
    )

    modal-visualizar-modelo(
      v-if='showModalVisualizar'
      :modalOpen='showModalVisualizar'
      :modelo='modeloEditar'
      @close-modal='closeModal()'
    )

</template>
<script>
import { Divider, AppNotificacao } from 'sicarf-components';
import { listar, deletar, pesquisar } from '@/services/modeloService';
import ModalNovoModelo from '@/components/modalNovoModelo';
import ModalVisualizarModelo from '@/components/modalVisualizarModelo';

export default {
  components: {
    Divider,
    ModalNovoModelo,
    ModalVisualizarModelo,
  },
  mixins: [
    AppNotificacao
  ],
  data() {
    return {
      pesquisa: '',
      showModalAdicionar: false,
      showModalVisualizar: false,
      loading: false,
      modelos: [],
      modeloEditar: null,
    }
  },
  created() {
    this.listarModelos();
  },

  methods: {
    async pesquisarModelos() {
      if (this.pesquisa === '') {
        this.listarModelos();
      } else {
        this.loading = true;
        try {
          this.modelos = await pesquisar(this.pesquisa);
          this.loading = false;
        } catch (e) {
          this.loading = false;
        }
      }
    },
    limpar() {
      this.pesquisa = '';
      this.listarModelos();
    },

    abrirModalAdicionar() {
      this.showModalAdicionar = true;
    },

    async listarModelos() {
      this.loading = true;
      try {
        this.modelos = await listar();
        this.loading = false;
      } catch (e) {
        this.loading = false;
      }
    },

    async abrirModelo(m) {
      this.modeloEditar = m;
      this.showModalVisualizar = true
    },

    async editarModelo(m) {
      this.modeloEditar = m;
      this.showModalAdicionar = true;
    },

    async excluirModelo(id) {
      this.loading = true;
      try {
        await deletar(id);
        this.showNotificacao(
          this.$messages.TIPO_SUCCESS,
          this.$messages.TITULO_SUCCESS,
          this.$messages.MODELO_EXCLUIDO
        )
        this.modelos = this.modelos.filter(m => {
          return m.id !== id
        });
        this.loading = false;
      } catch (e) {
        this.loading = false;
      }
    },

    closeModal() {
      this.showModalAdicionar = false;
      this.showModalVisualizar = false;
      this.modeloEditar = null;
    },

    refresh() {
      this.showModalAdicionar = false;
      this.modeloEditar = null;
      this.listarModelos();
    }
  }
}
</script>

<style scoped lang="scss">

.padding-titulo {
  margin-top: -5px;
}

.botao-limpar {
  color: #009f61;
  padding-top: 20px;
  cursor: pointer;
}

.titulo-tabela {
  font-size: 20px;
  font-weight: bold;
}

.marginLeft5 {
  margin-left: 5px;
}

.header {
  display: flex;
  justify-content: space-between;
}
</style>
